// src/analytics/tracker.js

import { getAuth } from "firebase/auth";

const LS_CONSENT_ANALYTICS = "mo_consent_analytics"; // "1" ili "0"
const LS_CONSENT_MARKETING = "mo_consent_marketing"; // "1" ili "0"



export function getConsent() {
  return {
    consent_analytics: localStorage.getItem(LS_CONSENT_ANALYTICS) === "1",
    consent_marketing: localStorage.getItem(LS_CONSENT_MARKETING) === "1",
  };
}

export function setConsent({ analytics, marketing }) {
  localStorage.setItem(LS_CONSENT_ANALYTICS, analytics ? "1" : "0");
  localStorage.setItem(LS_CONSENT_MARKETING, marketing ? "1" : "0");
}

const API = "https://modularobjects.com/marketing/api/events"; // tvoj Node endpoint
const LS_ANON = "mo_anon_id";
const LS_SESS = "mo_sess_id";
const LS_SESS_TS = "mo_sess_ts";
const SESSION_IDLE_MS = 30 * 60 * 1000;

function uuid() {
  // dovoljno dobro za tracking id (možeš zameniti crypto.randomUUID ako imaš)
  if (crypto?.randomUUID) return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function getCookie(name) {
  const m = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return m ? decodeURIComponent(m[2]) : null;
}

const LS_TC = "mo_track_code"; // sticky track_code

function getQueryParam(name) {
  const p = new URLSearchParams(window.location.search);
  const v = p.get(name);
  return v && v.trim() ? v.trim() : null;
}

function setCookie(name, value, days = 90) {
  const maxAge = days * 24 * 60 * 60;
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
}

export function getTrackCode() {
  // 1) tc iz URL-a ima prioritet
  const tc = getQueryParam("tc");
  if (tc) {
    localStorage.setItem(LS_TC, tc);
    setCookie("mo_track", tc, 90); // da backend i front budu usklađeni
    return tc;
  }

  // 2) cookie (ako je došao preko /track/:code)
  const c = getCookie("mo_track");
  if (c) {
    localStorage.setItem(LS_TC, c);
    return c;
  }

  // 3) sticky iz localStorage
  return localStorage.getItem(LS_TC) || null;
}

export function getAnonymousId() {
  let id = localStorage.getItem(LS_ANON);
  if (!id) {
    id = uuid();
    localStorage.setItem(LS_ANON, id);
  }
  return id;
}

export function getSessionId() {
  const now = Date.now();
  const last = Number(localStorage.getItem(LS_SESS_TS) || "0");
  let sid = localStorage.getItem(LS_SESS);

  const expired = !sid || !last || now - last > SESSION_IDLE_MS;
  if (expired) {
    sid = uuid();
    localStorage.setItem(LS_SESS, sid);
  }
  localStorage.setItem(LS_SESS_TS, String(now));
  return sid;
}

function readUtm() {
  const p = new URLSearchParams(window.location.search);
  return {
    utm_source: p.get("utm_source") || null,
    utm_medium: p.get("utm_medium") || null,
    utm_campaign: p.get("utm_campaign") || null,
    utm_content: p.get("utm_content") || null,
    utm_term: p.get("utm_term") || null,
    gclid: p.get("gclid") || null,
    fbclid: p.get("fbclid") || null,
    qr_id: p.get("qr") || p.get("qr_id") || null, // kako god ti je standard
  };
}

const LS_UTM = "mo_utm_v1";

function getStickyUtm() {
  const utm = readUtm();
  const hasAny = Object.values(utm).some(v => v && String(v).trim() !== "");

  if (hasAny) {
    localStorage.setItem(LS_UTM, JSON.stringify(utm));
    return utm;
  }

  try {
    return JSON.parse(localStorage.getItem(LS_UTM) || "{}");
  } catch {
    return {};
  }
}


export async function track(event_name, opts = {}) {
  const auth = getAuth();
  const currentUser = auth.currentUser;

  const {
    consent_analytics,
    consent_marketing,
    contact_id = null,
    firebase_uid,
    context = {},
    metadata = {},
  } = opts;

  const effectiveFirebaseUid = firebase_uid ?? currentUser?.uid ?? null;

  const c = getConsent();
  const ca = consent_analytics ?? c.consent_analytics;
  const cm = consent_marketing ?? c.consent_marketing;

  const allowWithoutAnalytics = event_name === "cookie_consent_update";

  if (!ca && !allowWithoutAnalytics) return;

  const baseContext = {
    route: window.location.pathname,
    lang: document.documentElement.lang || "",
    tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
    screen: { w: window.innerWidth, h: window.innerHeight },
  };

  const track_code = getTrackCode();

  const payload = {
    event_id: uuid(),
    event_name,
    event_ts: new Date().toISOString(),
    anonymous_id: getAnonymousId(),
    session_id: getSessionId(),
    track_code: track_code || null,
    contact_id,
    firebase_uid: effectiveFirebaseUid,
    page_url: window.location.pathname + window.location.search,
    referrer: document.referrer || "",
    ...getStickyUtm(),
    consent_analytics: !!ca,
    consent_marketing: !!cm,
    context: { ...baseContext, ...context },
    metadata,
    ua: navigator.userAgent || "",
  };

  try {
    await fetch(API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch {
  }
}